var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 18,
    height: 18,
    transform: "translate(255 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_57",
    "data-name": "Mask Group 57",
    transform: "translate(-255 -11)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(252.75 9.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M15.429,17.094l-1.665-1.665-.906.906,2.571,2.571,4.5-4.5-.906-.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M9.643,14.786h1.286v1.286H9.643Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M5.786,14.786H7.071v1.286H5.786Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M13.5,11.571h1.286v1.286H13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M9.643,11.571h1.286v1.286H9.643Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M5.786,11.571H7.071v1.286H5.786Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M13.5,8.357h1.286V9.643H13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M9.643,8.357h1.286V9.643H9.643Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M5.786,8.357H7.071V9.643H5.786Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M5.786,4.5h9V6.429h-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M10.929,19.286H3.86A1.29,1.29,0,0,1,2.571,18V2.569A1.284,1.284,0,0,1,3.855,1.286H16.717A1.284,1.284,0,0,1,18,2.569v9H16.714v-9H3.857V18h7.071Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinAccount);
export default __webpack_public_path__ + "static/media/fin-account.134329410902b5a3aa0df572cc6f6a74.svg";
export { ForwardRef as ReactComponent };